import UserActionError from '@/interfaces/errors/userAction';
const PREFIX = 'features: WidgetEdit: hooks: useWidgetUpdate:';
export const USER_MESSAGES = {
  badRequest: 'Updates are invalid, please correct any issues or contact support',
  unpermissioned: 'You do not have permission to make these changes, please login again or contact an admin',
  unpaid: 'You require a subscription to make these changes, please subscribe and try again',
  unknown: 'Failed to complete request, please try again or contact support'
};
export const UPDATE_REPORTER_USER_MESSAGES = {
  badRequest: 'Selected reporting widget was invalid, please correct any issues with the widget or contact support',
  unpermissioned: 'You do not have permission to make these changes, please login again or contact an admin',
  unknown: 'Failed to update the subscribing widget, please try again or contact support'
};
export const createBadWidgetSaveReqError = (prefix, err) => {
  const badReqErr = new UserActionError(`${prefix} bad request: ${err}`);
  badReqErr.userMessage = USER_MESSAGES.badRequest;
  badReqErr.code = `${PREFIX}badRequest`;
  badReqErr.stack = err.stack;
  return badReqErr;
};
export const createUnauthWidgetSaveReqError = (prefix, err) => {
  const badReqErr = new UserActionError(`${prefix} unauthorized request: ${err}`);
  badReqErr.userMessage = USER_MESSAGES.unpermissioned;
  badReqErr.code = `${PREFIX}unpermissioned`;
  badReqErr.stack = err.stack;
  return badReqErr;
};
export const createUnknownWidgetSaveReqError = (prefix, err) => {
  const badReqErr = new UserActionError(`${prefix} unknown error: ${err}`);
  badReqErr.userMessage = USER_MESSAGES.unknown;
  badReqErr.code = `${PREFIX}unknown`;
  badReqErr.stack = err.stack;
  return badReqErr;
};
export const createUnpaidWidgetSaveReqError = (prefix, err) => {
  const badReqErr = new UserActionError(`${prefix} unpaid/unsubscribed error: ${err}`);
  badReqErr.userMessage = USER_MESSAGES.unpaid;
  badReqErr.code = `${PREFIX}unpaid`;
  badReqErr.stack = err.stack;
  return badReqErr;
};
export const createBadReporterReqError = (prefix, err) => {
  const badReqErr = new UserActionError(`${prefix} bad request error: ${err}`);
  badReqErr.userMessage = UPDATE_REPORTER_USER_MESSAGES.badRequest;
  badReqErr.code = `${PREFIX}badRequest`;
  badReqErr.stack = err.stack;
  return badReqErr;
};
export const createUnauthReporterReqError = (prefix, err) => {
  const badReqErr = new UserActionError(`${prefix} unauthed error: ${err}`);
  badReqErr.userMessage = UPDATE_REPORTER_USER_MESSAGES.unpermissioned;
  badReqErr.code = `${PREFIX}unpermissioned`;
  badReqErr.stack = err.stack;
  return badReqErr;
};
export const createUnknownReporterReqError = (prefix, err) => {
  const badReqErr = new UserActionError(`${prefix} unknown error: ${err}`);
  badReqErr.userMessage = UPDATE_REPORTER_USER_MESSAGES.unknown;
  badReqErr.code = `${PREFIX}unknown`;
  badReqErr.stack = err.stack;
  return badReqErr;
};